import { GeneralService } from './../../../services/general.service';
import { FormGroup, Validators } from '@angular/forms';

export class FormCamisaTrieurBuild {

  public async buildForm(form: FormGroup, arrForm: Array<FormGroup>, generalService: GeneralService): Promise<FormGroup> {
    form = await this.buildFormI(form, arrForm[0], generalService);
    form = await this.buildFormII(form, arrForm[1], generalService);
    form = await this.buildFormIII(form, arrForm[2], generalService);
    form = await this.buildFormIV(form, arrForm[3], generalService);

    return form;
  }

  private async buildFormI(form: FormGroup, formCard: FormGroup, generalService: GeneralService): Promise<FormGroup> {


    form.get('site').setValue(formCard.get('site_recebimento')?.value)
    form.get('data_estrategia').setValue(generalService.createDate(formCard.get('data_estrategia')?.value))
    form.get('hibrido_rnc').setValue(formCard.get('hibrido_rnc_linhagem')?.value)
    form.get('safra').setValue(formCard.get('safra')?.value)
    form.get('lote_ds').setValue(formCard.get('lote_ds')?.value)
    form.get('volume_analisado_kg').setValue(formCard.get('volume_analisado')?.value)

    return await form;
  }

  private async buildFormII(form: FormGroup, formCard: FormGroup, generalService: GeneralService): Promise<FormGroup> {

    form.get('rendimento_r1m').setValue(formCard.get('rendimento_r1m')?.value)
    form.get('rendimento_r2').setValue(formCard.get('rendimento_r2')?.value)
    form.get('rendimento_r3').setValue(formCard.get('rendimento_r3')?.value)
    form.get('rendimento_c1m').setValue(formCard.get('rendimento_c1m')?.value)
    form.get('rendimento_c2').setValue(formCard.get('rendimento_c2')?.value)
    form.get('rendimento_c3').setValue(formCard.get('rendimento_c3')?.value)
    form.get('min_r1m').setValue(formCard.get('min_r1m')?.value)
    form.get('min_r2').setValue(formCard.get('min_r2')?.value)
    form.get('min_r3').setValue(formCard.get('min_r3')?.value)
    form.get('min_c1m').setValue(formCard.get('min_c1m')?.value)
    form.get('min_c2').setValue(formCard.get('min_c2')?.value)
    form.get('min_c3').setValue(formCard.get('min_c3')?.value)
    form.get('max_r1m').setValue(formCard.get('max_r1m')?.value)
    form.get('max_r2').setValue(formCard.get('max_r2')?.value)
    form.get('max_r3').setValue(formCard.get('max_r3')?.value)
    form.get('max_c1m').setValue(formCard.get('max_c1m')?.value)
    form.get('max_c2').setValue(formCard.get('max_c2')?.value)
    form.get('max_c3').setValue(formCard.get('max_c3')?.value)
    form.get('range_r1m').setValue(formCard.get('range_r1m')?.value)
    form.get('range_r2').setValue(formCard.get('range_r2')?.value)
    form.get('range_r3').setValue(formCard.get('range_r3')?.value)
    form.get('range_c1m').setValue(formCard.get('range_c1m')?.value)
    form.get('range_c2').setValue(formCard.get('range_c2')?.value)
    form.get('range_c3').setValue(formCard.get('range_c3')?.value)
    form.get('sdev_r1m').setValue(formCard.get('sdev_r1m')?.value)
    form.get('sdev_r2').setValue(formCard.get('sdev_r2')?.value)
    form.get('sdev_r3').setValue(formCard.get('sdev_r3')?.value)
    form.get('sdev_c1m').setValue(formCard.get('sdev_c1m')?.value)
    form.get('sdev_c2').setValue(formCard.get('sdev_c2')?.value)
    form.get('sdev_c3').setValue(formCard.get('sdev_c3')?.value)
    form.get('resultado_r1m').setValue(formCard.get('resultado_r1m')?.value)
    form.get('resultado_r2').setValue(formCard.get('resultado_r2')?.value)
    form.get('resultado_r3').setValue(formCard.get('resultado_r3')?.value)
    form.get('resultado_c1m').setValue(formCard.get('resultado_c1m')?.value)
    form.get('resultado_c2').setValue(formCard.get('resultado_c2')?.value)
    form.get('resultado_c3').setValue(formCard.get('resultado_c3')?.value)


    return await form;
  }


  private async buildFormIII(form: FormGroup, formCard: FormGroup, generalService: GeneralService): Promise<FormGroup> {
    form.get('linha').setValue(formCard.get('linha')?.value)
    form.get('peneira').setValue(formCard.get('peneira')?.value)
    form.get('tag_trieur').setValue(formCard.get('tag_trieur')?.value)
    form.get('camisa').setValue(formCard.get('camisa')?.value)
    form.get('fracao_enviada_silo').setValue(formCard.get('fracao_enviada_silo')?.value)
    return await form;
  }


  private async buildFormIV(form: FormGroup, formCard: FormGroup, generalService: GeneralService): Promise<FormGroup> {
    form.get('responsavel_lancamento').setValue(formCard.get('responsavel_lancamento')?.value)
    form.get('responsavel_analise').setValue(formCard.get('responsavel_analise')?.value)
    form.get('observacoes').setValue(formCard.get('observacao')?.value)

    return await form;
  }



  public async updateForm(form: FormGroup, arrForm: Array<FormGroup>, generalService: GeneralService): Promise<void> {
    await this.updateFormI(form, arrForm[0], generalService);
    await this.updateFormII(form, arrForm[1], generalService);
    await this.updateFormIII(form, arrForm[2], generalService);
    await this.updateFormIV(form, arrForm[3], generalService);
  }

  private async updateFormI(data: any, formCard: FormGroup, generalService: GeneralService): Promise<void> {
    const loteDs = data.formulario.lote_ds;
    const parsedValue = loteDs ? loteDs.split(',') : [];

    formCard.get('site_recebimento').setValue(data.formulario.site);
    formCard.get('data_estrategia').setValue(generalService.convertStringToDate(data.formulario.data_estrategia))
    formCard.get('hibrido_rnc_linhagem').setValue(data.formulario.hibrido_rnc);
    formCard.get('safra').setValue(data.formulario.safra);
    formCard.get('lote_ds').setValue(parsedValue);
    formCard.get('volume_analisado').setValue(data.formulario.volume_analisado_kg);

  }
  private async updateFormII(data: any, formCard: FormGroup, generalService: GeneralService): Promise<void> {
    formCard.get('rendimento_r1m').setValue(data.formulario.rendimento_r1m);
    formCard.get('rendimento_r2').setValue(data.formulario.rendimento_r2);
    formCard.get('rendimento_r3').setValue(data.formulario.rendimento_r3);
    formCard.get('rendimento_c1m').setValue(data.formulario.rendimento_c1m);
    formCard.get('rendimento_c2').setValue(data.formulario.rendimento_c2);
    formCard.get('rendimento_c3').setValue(data.formulario.rendimento_c3);
    formCard.get('min_r1m').setValue(data.formulario.min_r1m);
    formCard.get('min_r2').setValue(data.formulario.min_r2);
    formCard.get('min_r3').setValue(data.formulario.min_r3);
    formCard.get('min_c1m').setValue(data.formulario.min_c1m);
    formCard.get('min_c2').setValue(data.formulario.min_c2);
    formCard.get('min_c3').setValue(data.formulario.min_c3);
    formCard.get('max_r1m').setValue(data.formulario.max_r1m);
    formCard.get('max_r2').setValue(data.formulario.max_r2);
    formCard.get('max_r3').setValue(data.formulario.max_r3);
    formCard.get('max_c1m').setValue(data.formulario.max_c1m);
    formCard.get('max_c2').setValue(data.formulario.max_c2);
    formCard.get('max_c3').setValue(data.formulario.max_c3);
    formCard.get('range_r1m').setValue(data.formulario.range_r1m);
    formCard.get('range_r2').setValue(data.formulario.range_r2);
    formCard.get('range_r3').setValue(data.formulario.range_r3);
    formCard.get('range_c1m').setValue(data.formulario.range_c1m);
    formCard.get('range_c2').setValue(data.formulario.range_c2);
    formCard.get('range_c3').setValue(data.formulario.range_c3);
    formCard.get('sdev_r1m').setValue(data.formulario.sdev_r1m);
    formCard.get('sdev_r2').setValue(data.formulario.sdev_r2);
    formCard.get('sdev_r3').setValue(data.formulario.sdev_r3);
    formCard.get('sdev_c1m').setValue(data.formulario.sdev_c1m);
    formCard.get('sdev_c2').setValue(data.formulario.sdev_c2);
    formCard.get('sdev_c3').setValue(data.formulario.sdev_c3);
    formCard.get('resultado_r1m').setValue(data.formulario.resultado_r1m);
    formCard.get('resultado_r2').setValue(data.formulario.resultado_r2);
    formCard.get('resultado_r3').setValue(data.formulario.resultado_r3);
    formCard.get('resultado_c1m').setValue(data.formulario.resultado_c1m);
    formCard.get('resultado_c2').setValue(data.formulario.resultado_c2);
    formCard.get('resultado_c3').setValue(data.formulario.resultado_c3);


  }
  private async updateFormIII(data: any, formCard: FormGroup, generalService: GeneralService): Promise<void> {
    formCard.get('linha').setValue(data.formulario.linha);
    formCard.get('peneira').setValue(data.formulario.peneira);
    formCard.get('tag_trieur').setValue(data.formulario.tag_trieur);
    formCard.get('camisa').setValue(data.formulario.camisa);
    formCard.get('fracao_enviada_silo').setValue(data.formulario.fracao_enviada_silo);

  }
  private async updateFormIV(data: any, formCard: FormGroup, generalService: GeneralService): Promise<void> {
    formCard.get('responsavel_lancamento').setValue(data.formulario.responsavel_lancamento);
    formCard.get('responsavel_analise').setValue(data.formulario.responsavel_analise);
    formCard.get('observacao').setValue(data.formulario.observacoes);

  }

}

